<div class="price-information" fxLayout="column" fxLayoutAlign="center" *ngIf="visible">
  <div fxLayout="row">
    <div class="price-information-label">{{ 'STEPCONTAINER.GROSSPRICE' | translate }}</div>
    <div fxFlex></div>
    <div class="price-information-value" *ngIf="!invalid && !priceLoading">
      {{ price | currency: 'EUR' : 'symbol' : '1.2-2' : currentLocale }}
    </div>
    <div class="price-information-value" *ngIf="invalid && !priceLoading">?</div>
    <div class="price-information-value" *ngIf="priceLoading">...</div>
  </div>
</div>
